import * as def from '../Defs/subscriptiondefs'

export const updateGuidelineGPTUsage = (payload) => ({
    type: def.UPDATE_GUIDELINE_GPT_USAGE,
    payload: payload,
  });

export const updateScenarioDeskUsage = (payload) => ({
    type: def.UPDATE_SCENARIO_DESK_USAGE,
    payload: payload,
  });
  

export const updateMISMOUsage = (payload) => ({
    type: def.UPDATE_MISMO_USAGE,
    payload: payload,
  });

export const updateForm1003Usage = (payload) => ({
    type: def.UPDATE_FORM1003_USAGE,
    payload: payload,
  });

export const setShowFeedback = (show) => ({
    type: 'SET_SHOW_FEEDBACK',
    payload: show,
});

export const setSelectedProduct = (product) => ({
    type: 'SET_SELECTED_PRODUCT',
    payload: product,
});

export const setSelectedFeature = (feature) => ({
    type: 'SET_SELECTED_FEATURE',
    payload: feature,
});